module.exports = __webpack_public_path__ + "static/media/paid.6a98d1c3.png";